import { render, staticRenderFns } from "./BarEdpByRegionChart.vue?vue&type=template&id=63843752&"
import script from "./BarEdpByRegionChart.vue?vue&type=script&lang=ts&"
export * from "./BarEdpByRegionChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports